// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"BlockSeo_landingContainer__DwaU_","blockSeo":"BlockSeo_blockSeo__OEqu1"};